// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2x32s","info":"UpdateTermsInfo_info__2nTRM"};